import { PropsWithChildren } from 'react';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip } from '@frontend/design-system';

type AiInfoChipProps = {
  iconName: IconName;
};

export const AiIconChip = ({ iconName, children }: PropsWithChildren<AiInfoChipProps>) => {
  return (
    <Chip
      css={{
        marginLeft: 8,
        fontSize: theme.font.size.small,
        color: theme.font.colors.default,
        background: `linear-gradient(90deg, ${theme.colors.primary10} 0%, #def9f9 100%)`,
        padding: theme.spacing(0.5, 0.5),
      }}
    >
      <Icon
        name={iconName}
        size={16}
        css={{ display: 'inline-block', verticalAlign: 'middle', marginRight: theme.spacing(0.5) }}
      />
      {children}
    </Chip>
  );
};
